import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { type ReportSearch, reportSearchFrom } from '@/features/accounting-reports/api'
import { TaxScreen } from '@/features/accounting-reports/tax-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/tax')({
  validateSearch: (search: Record<string, unknown>): ReportSearch => reportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: TaxRoute,
})

function TaxRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <TaxScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/accounting/reports/tax', search: next })}
    />
  )
}
